import { BaseContainerModel } from '../../../base-container.model';
import { bl_del_job_hdr_RowClass } from '../../../../dbschema/bl_del_job_hdr.model';
import { bl_del_driver_hdr_RowClass, bl_del_job_attachment_RowInterface, bl_del_job_dochdr_link_RowClass, bl_del_job_docline_link_RowClass, bl_del_job_event_RowClass, bl_del_trip_hdr_RowClass, bl_del_vehicle_hdr_RowClass } from '../../../../dbschema';

export class JobDocsContainerModel extends BaseContainerModel {
    bl_del_job_hdr: bl_del_job_hdr_RowClass = new bl_del_job_hdr_RowClass();
    bl_del_job_attachments: bl_del_job_attachment_RowInterface[] = [];
    bl_del_job_events: bl_del_job_event_RowClass[] = [];
    bl_del_job_dochdr_link: bl_del_job_dochdr_link_RowClass[] = [];
    bl_del_job_dochdr_attachments: any[] = [];  //* Not sure what the type here should be yet
    bl_del_job_docline_links: bl_del_job_docline_link_RowClass[] = [];
    bl_del_job_docline_attachments: any[] = []; //* Not sure what the type here should be yet
    bl_del_trip_hdr: bl_del_trip_hdr_RowClass;
    bl_del_driver_hdr: bl_del_driver_hdr_RowClass[] = [];
    bl_del_vehicle_hdr: bl_del_vehicle_hdr_RowClass;
}